/**
 * 页头或页脚 fixed 布局
 *
 * 用例：
 * ```js
 * <AbsoluteLayout>
 *  <AbsoluteLayoutHeader height='1rem'>
 *    <div>fixed header content</div>
 *  </AbsoluteLayoutHeader>
 *
 *  <AbsoluteLayoutBody headerHeight='1rem' footerHeight='0.9rem'>
 *    <div>main content  scroll-y auto</div>
 *  </AbsoluteLayoutBody>
 *
 *  <AbsoluteLayoutFooter height='0.9rem'>
 *    <div>fixed footer content</div>
 *  </AbsoluteLayoutFooter>
 * </AbsoluteLayout>
 * ```
 */


import React from 'react';
import propTypes from 'prop-types';

import './index.css';

import classNames from 'classnames';



// AbsoluteLayout 的祖先元素必须设置高度，一般需求为 100%
export default function AbsoluteLayout(props) {
  let {className, children, ...rest} = props;
  let cls = classNames('component-absolute-layout', className);

  return (
    <div {...rest} className={cls}>{children}</div>
  );
}


AbsoluteLayoutHeader.propTypes = {
  height: propTypes.string
};

AbsoluteLayoutHeader.defaultProps = {
  style: {}
};

export function AbsoluteLayoutHeader(props) {
  let {className, children, style, height, ...rest} = props;

  style = {...style, height};
  let cls = classNames(className);

  return (
    <header {...rest} className={cls} style={style}>{children}</header>
  );
}




AbsoluteLayoutFooter.propTypes = {
  height: propTypes.string
};

AbsoluteLayoutFooter.defaultProps = {
  style: {}
};

export function AbsoluteLayoutFooter(props) {
  let {className, children, style, height, ...rest} = props;

  style = {...style, height};
  className = classNames(className);

  return (
    <footer {...rest} className={className} style={style}>{children}</footer>
  );
}



export class AbsoluteLayoutBody extends React.Component {
  static propTypes = {
    headerHeight: propTypes.string,
    footerHeight: propTypes.string
  };

  static defaultProps = {
    style: {}
  };

  scrollContainer = null;

  render() {
    let {
      className,
      children,
      style,
      headerHeight,
      footerHeight,
      onScroll,
      ...rest
    } = this.props;

    style = {
      ...style,
      paddingTop: headerHeight,
      paddingBottom: footerHeight
    };

    let cls = className ? `${className}-body` : '';

    return (
      <main {...rest} className={classNames(className)} style={style}>
        <div
          ref={(node) => {
            node && (this.scrollContainer = node);
          }}
          className={cls}
          onScroll={onScroll}>

          {children}
        </div>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FixedLayout/absolute/index.js